export default __webpack_public_path__ + "static/media/sumo-interface_1_tutorial_scenario_simulation.4f0df1d2.png";